export const MuiFormHelperText = {
  styleOverrides: {
    root: {
      marginLeft: 0,
      fontWeight: 500,
    },
  },
};
